var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "computer-user_interface-programing-code-coding",
    "data-name": "computer-user interface-programing-code-coding"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61,5V43H3V5A2.006,2.006,0,0,1,5,3H59A2.006,2.006,0,0,1,61,5Z",
    style: {
      fill: "#ffcd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,43H61V5A38,38,0,0,1,23,43Z",
    style: {
      fill: "#ebbf00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,43v4a2.006,2.006,0,0,0,2,2H59a2.006,2.006,0,0,0,2-2V43Z",
    style: {
      fill: "#004fac"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 49,
    width: 12,
    height: 6,
    style: {
      fill: "#939598"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,55a2,2,0,0,0-2,2v4H47V57a2,2,0,0,0-2-2H19Z",
    style: {
      fill: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 49,
    width: 12,
    height: 2,
    style: {
      fill: "#808285"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.882,11h0a2.119,2.119,0,0,0-1.5.621L8.414,21.586a2,2,0,0,0,0,2.828l9.965,9.965a2.119,2.119,0,0,0,1.5.621h0a2.12,2.12,0,0,0,1.5-3.619L13,23l8.381-8.381A2.12,2.12,0,0,0,19.882,11Z",
    style: {
      fill: "#ed1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.621,11.621a2.119,2.119,0,0,0-1.5-.621h0a2.12,2.12,0,0,0-1.5,3.619L51,23l-8.381,8.381A2.12,2.12,0,0,0,44.118,35h0a2.119,2.119,0,0,0,1.5-.621l9.965-9.965a2,2,0,0,0,0-2.828Z",
    style: {
      fill: "#ed1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.814,7.025a2,2,0,0,0-2.563,1.2L24.99,36.411a2,2,0,1,0,3.759,1.368L39.01,9.589A2,2,0,0,0,37.814,7.025Z",
    style: {
      fill: "#ed1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,2H5A3.009,3.009,0,0,0,2,5V47a3.009,3.009,0,0,0,3,3H25v4H19a3.009,3.009,0,0,0-3,3v4a1,1,0,0,0,1,1H47a1,1,0,0,0,1-1V57a3.009,3.009,0,0,0-3-3H39V50H59a3.009,3.009,0,0,0,3-3V5A3.009,3.009,0,0,0,59,2ZM45,56a1,1,0,0,1,1,1v3H18V57a1,1,0,0,1,1-1ZM27,54V50H37v4Zm33-7a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V44H60Zm0-5H4V5A1,1,0,0,1,5,4H59a1,1,0,0,1,1,1Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,45H31a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.672,35.086A3.1,3.1,0,0,0,19.878,36h0a3.12,3.12,0,0,0,2.206-5.326L14.414,23l7.674-7.674a3.121,3.121,0,0,0-4.416-4.412L7.707,20.879a3,3,0,0,0,0,4.242ZM9.121,22.293l9.965-9.965a1.118,1.118,0,0,1,.8-.328,1.12,1.12,0,0,1,.792,1.912l-8.381,8.381a1,1,0,0,0,0,1.414l8.381,8.381A1.12,1.12,0,0,1,19.882,34h0a1.116,1.116,0,0,1-.792-.328L9.121,23.707A1,1,0,0,1,9.121,22.293Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.236,34.074A3.072,3.072,0,0,0,44.118,36h0a3.1,3.1,0,0,0,2.206-.914l9.965-9.965a3,3,0,0,0,0-4.242l-9.965-9.965a3.121,3.121,0,1,0-4.416,4.412L49.586,23l-7.674,7.674A3.072,3.072,0,0,0,41.236,34.074Zm2.09-1.986,8.381-8.381a1,1,0,0,0,0-1.414l-8.381-8.381a1.12,1.12,0,0,1,.8-1.912,1.116,1.116,0,0,1,.792.328l9.965,9.965a1,1,0,0,1,0,1.414l-9.965,9.965a1.116,1.116,0,0,1-.792.328h0a1.12,1.12,0,0,1-.792-1.912Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.872,40.1a3.019,3.019,0,0,1-1.028-.182h0a3,3,0,0,1-1.793-3.846L34.312,7.879a3,3,0,1,1,5.637,2.052L29.688,38.121A3,3,0,0,1,26.872,40.1ZM37.129,7.9a1.007,1.007,0,0,0-.939.659L25.93,36.753a1,1,0,0,0,.6,1.282h0a1,1,0,0,0,1.282-.6L38.07,9.247A1,1,0,0,0,37.129,7.9Z",
    style: {
      fill: "#231f20"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.c12ccc9b78407e69d393b27d4cfa511d.svg";
export { ForwardRef as ReactComponent };